// externals
import { useSelector } from 'react-redux';

// libraries
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';

// styles
import {
    CreditAndFinanceTitle,
    CreditAndFinanceWrapper,
    CreditBureauContainer,
    LenderDecisionContainer,
    CreditAndFinanceTitleWrapper,
    CreditApplicant
} from './CreditDecision.style';

// components
import LenderDecisionInfo from './LenderDecisionInfo';

export const CreditDecision = () => {
    const toggleEnableLenderDecisionsInCreditBureau = useSelector(featureToggleSelectors.isEnableLenderDecisionsInCreditBureau);
    const shopper = useSelector(offerReduxSelectors.getShopperInfo);
    const { firstName, lastName } = shopper;

    return (
        <>
            <CreditBureauContainer data-testid="credit-decision-interstate-container">
                <CreditAndFinanceWrapper>
                    <CreditAndFinanceTitleWrapper>
                        <CreditAndFinanceTitle data-testid="credit-and-finance-title">Credit Decisions</CreditAndFinanceTitle>
                        <CreditApplicant data-testid="applicant">
                            Applicant: {firstName} {lastName}
                        </CreditApplicant>
                    </CreditAndFinanceTitleWrapper>
                    {toggleEnableLenderDecisionsInCreditBureau && (
                        <LenderDecisionContainer data-testid="lender-decision-container">
                            <LenderDecisionInfo data-testid="lender-decision-layout" />
                        </LenderDecisionContainer>
                    )}
                </CreditAndFinanceWrapper>
            </CreditBureauContainer>
        </>
    );
};
